"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToBiggerUnit = void 0;
const roundToBiggerUnit = (currentUnitValue, nextUnitValue, roundValue) => {
    return (currentUnitValue <= roundValue ? nextUnitValue : nextUnitValue + 1).toString();
};
exports.roundToBiggerUnit = roundToBiggerUnit;
//# sourceMappingURL=roundToBiggerUnit.js.map